<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Network Settings</h4>
      </div>
    </div>
    <div class="row" v-if="[3, 4].includes(logged_in_user.group_id)">
      <div class="col-8">
        <div class="alert alert-danger" role="alert">
          <b>Warning:</b> If incorrect data is entered here, you will need physical access to the machine to fix it.
        </div>
        <div class="alert alert-warning" role="alert">
          <b>Notice:</b> Changing Network Settings requires that the machine be restarted to take effect.
        </div>
        
        <form>
          <div v-for="network_interface in sorted_network_interfaces" :key="network_interface.network_interface_id">
            <h5>{{ network_interface.name }}</h5>
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="network_interface.enabled">
                Enabled
              </label>
            </div>
            <div class="form-group">
              <label>IP Assignment</label>
              <select class="form-control" v-model="network_interface.type">
                <option value="1">Static</option>
                <option value="2">DHCP</option>
                <option value="3">Unconfigured</option>
              </select>
            </div>
            <div v-if="showConfig(network_interface.type)">
              <div class="form-group">
                <label>IP</label>
                <input type="text" class="form-control" v-model="network_interface.ip">
              </div>
              <div class="form-group">
                <label>Netmask</label>
                <input type="text" class="form-control" v-model="network_interface.netmask">
              </div>
              <div class="form-group">
                <label>Gateway</label>
                <input type="text" class="form-control" v-model="network_interface.gateway">
              </div>
            </div>
            <br><br>
          </div>

          <button type="submit" class="btn btn-hub-primary" @click="save()">Save</button>
        </form>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-8">
        <form>
          <div v-for="network_interface in sorted_network_interfaces" :key="network_interface.network_interface_id">
            <h5>{{ network_interface.name }}</h5>
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="network_interface.enabled" disabled>
                Enabled
              </label>
            </div>
            <div class="form-group">
              <label>IP Assignment</label>
              <select class="form-control" v-model="network_interface.type" disabled>
                <option value="1">Static</option>
                <option value="2">DHCP</option>
                <option value="3">Unconfigured</option>
              </select>
            </div>
            <div v-if="showConfig(network_interface.type)">
              <div class="form-group">
                <label>IP</label>
                <input type="text" class="form-control" v-model="network_interface.ip" disabled>
              </div>
              <div class="form-group">
                <label>Netmask</label>
                <input type="text" class="form-control" v-model="network_interface.netmask" disabled>
              </div>
              <div class="form-group">
                <label>Gateway</label>
                <input type="text" class="form-control" v-model="network_interface.gateway" disabled>
              </div>
            </div>
            <br><br>
          </div>

          <button type="submit" class="btn btn-hub-primary" @click="save()">Save</button>
          
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'network',
  data: function () {
    return {}
  },
  computed: {
    ...mapGetters({
      network_interfaces: 'allNetworkInterfaces',
      logged_in_user: 'loggedInUser',
    }),
    sorted_network_interfaces: function () {
      let top_ids = [6,7]
      // quick and dirty solution to get the most desired interfaces to the top. top_ids can easily be changed in the future.
      return this.network_interfaces.sort((a, b) => {
        if (top_ids.includes(a.network_interface_id) && top_ids.includes(b.network_interface_id)) {
          return (a.network_interface_id - b.network_interface_id)
        }
        if (top_ids.includes(a.network_interface_id) || top_ids.includes(b.network_interface_id)) {
          return 1
        }
        return a.network_interface_id - b.network_interface_id
      })
    }
  },
  created () {
    this.$store.dispatch('getNetworkInterfaces')
  },
  methods: {
    showConfig (type) {
      return type === '1' || type === 1
    },
    save () {
      this.$store.dispatch('saveNetworkInterfaces', { 'network_interfaces': this.network_interfaces })
    }
  }
}
</script>

<style scoped>
</style>
